import React from 'react';
import { Button, Switch } from '@iwoca/orion';
import { Trans } from '@lingui/macro';
import { SortableList } from 'components/SortableList/SortableList';
import { useApplicationTableState } from 'contexts/ApplicationTableStateContext/ApplicationTableStateContext';
import { TTableFilterName, TColumnConfiguration } from 'types';
import styles from './ColumnSettings.module.css';

export const ColumnSettings = () => {
  const {
    columnConfig,
    reorderColumns,
    toggleColumnDisplay,
    displayAllColumns,
  } = useApplicationTableState();

  return (
    <div className={styles.columnSettings}>
      <h3 className={styles.heading}>
        <Trans>Customise columns</Trans>
      </h3>
      <p className={styles.subHeading}>
        <Trans>
          Change what columns you want to display or drag to reorder the column.
        </Trans>
      </p>

      <SortableList
        items={columnConfig.map(({ key }) => key)}
        onChange={(keys) => reorderColumns(keys as TTableFilterName[])}
        itemRenderer={({ item: key }) => {
          const { label, display } = columnConfig.find(
            (item) => item.key === key,
          ) as TColumnConfiguration;
          return (
            <div className={styles.columnSetting}>
              <span className={styles.label}>{label}</span>
              <Switch
                data-testid={`display-toggle-${key}`}
                checked={display}
                // TODO: Change to onChange when onChange is fixed in the orion repo
                onClick={() => toggleColumnDisplay(key as TTableFilterName)}
              />
            </div>
          );
        }}
        controlled
      />
      <Button
        onClick={displayAllColumns}
        className={styles.displayAllButton}
        variant="secondary-alt"
      >
        <Trans>Reset columns to default</Trans>
      </Button>
    </div>
  );
};
